import React from 'react';
import { Flex, Typography } from 'antd';
import ReactMarkdown from 'react-markdown';

export const Prompt = ({ data }: { data: string[] }) => {
    if (!data) return;

    return (
        <Flex vertical>
            {data.map((item, index) => (
                <Typography.Text key={index}>
                    <ReactMarkdown>{item}</ReactMarkdown>
                </Typography.Text>
            ))}
        </Flex>
    );
};
